import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  cardTextWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: '10px'
  },
  labelText: {
    fontFamily: 'BentonSansMedium',
    marginRight: '5px !important'
  },
  paragraphText: {
    fontFamily: ({ emphasis }) => emphasis === 'bold' ? 'BentonSansMedium' : 'BentonSansRegular'
  },
  title: {
    fontWeight: [600, '!important']
  }
})

export default useStyles
